import axios from "../axios";

function getOrderById(id) {
  return axios.get("/orders/" + id);
}

export { getOrderById };
